import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { SimpleDialogContent } from '../@common/simpleDialog.component';
import * as Moment from 'moment';

import { NgbDateCustomFormatter } from './@Utils';

@Component({
    selector: 'input-datetime-content',
    template: `
<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button class="btn btn-primary"  (click)="clickReset()">初期化</button>
  <!-- 
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
  -->
</div>
<div class="card-body">
  <!-- <form class="form-inline mb-3"> -->
      <div class="toggle-example" style="display: flex;white-space: nowrap;">
        時間 :&nbsp;<input class="form-control" placeholder="MM:SS" [format]="24"
          [ngxTimepicker]="inputTimePicker1" [(ngModel)]="inputTime1"
          [disableClick]="true" style="background-color: antiquewhite; width:76px">
        <ngx-material-timepicker-toggle [for]="inputTimePicker1"></ngx-material-timepicker-toggle>
        <ngx-material-timepicker #inputTimePicker1 [minutesGap]="30"></ngx-material-timepicker>
        〜
        <input class="form-control" placeholder="MM:SS" [format]="24"
          [ngxTimepicker]="inputTimePicker2" [(ngModel)]="inputTime2"
          [disableClick]="true" style="background-color: antiquewhite; width:76px;display:inline">
        <ngx-material-timepicker-toggle [for]="inputTimePicker2"></ngx-material-timepicker-toggle>
        <ngx-material-timepicker #inputTimePicker2 [minutesGap]="30"></ngx-material-timepicker>
        </div>
        <span *ngIf="validateMessage != null">
        <font color=red size=2 style="vertical-align:top">{{validateMessage}}</font>
        </span>
        <br>
        <div>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('0')" id="sun"><span style="position:relative;top:-6px; left:-6px;">日</span></button><span style="font-size:10px;">&nbsp;</span>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('1')" id="mon"><span style="position:relative;top:-6px; left:-6px;">月</span></button><span style="font-size:10px;">&nbsp;</span>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('2')" id="tue"><span style="position:relative;top:-6px; left:-6px;">火</span></button><span style="font-size:10px;">&nbsp;</span>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('3')" id="wed"><span style="position:relative;top:-6px; left:-6px;">水</span></button><span style="font-size:10px;">&nbsp;</span>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('4')" id="thu"><span style="position:relative;top:-6px; left:-6px;">木</span></button><span style="font-size:10px;">&nbsp;</span>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('5')" id="fri"><span style="position:relative;top:-6px; left:-6px;">金</span></button><span style="font-size:10px;">&nbsp;</span>
        <button class="btn btn-primary" style="WIDTH: 33px; HEIGHT: 33px; font-size:20px;" (click)="clickDayOfTheWeek('6')" id="sat"><span style="position:relative;top:-6px; left:-6px;">土</span></button><span style="font-size:10px;">&nbsp;</span>
        </div>
        </div>
<br>
<div class="modal-footer">
  <button class="btn btn-secondary mr-auto" (click)="activeModal.close('cancel')">キャンセル</button>
  <button class="btn btn-primary"  (click)="clickOK()">OK</button>
</div>
`,
    providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomFormatter },
    ]
})

/**
 * 登録不可時間設定ダイアログ
 */
export class InputUnregistrationTimeContent {
    @Input() title;             //タイトル
    @Input() validateMessage;   //エラーメッセージ
    private inputTime1: string; //開始時間
    private inputTime2: string; //終了時間
    private input_day_of_the_week: string[];    //青色にする曜日

    constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) {
        //曜日（0〜6：日〜土）
        this.input_day_of_the_week = ['0', '1', '2', '3', '4', '5', '6']
    }

    set inputTime1_(date: string) {
        this.inputTime1 = date;
    }
    get inputTime1_() {
        return this.inputTime1;
    }

    set inputTime2_(date: string) {
        this.inputTime2 = date;
    }

    get inputTime2_() {
        return this.inputTime2;
    }

    set inputDayOfTheWeek(str: string) {
        //null判定
        if (str != null) {
            //nullでない場合
            //','で区切って結合されている曜日を配列にする
            this.input_day_of_the_week = str.split(',');
        } else {
            //nullである場合（登録不可時間が設定されていない場合）
            this.input_day_of_the_week = [];
        }
    }

    get inputDayOfTheWeek() {
        //配列を','で区切って結合
        return this.input_day_of_the_week.join(',');
    }

    /**
     * OKボタン押下処理
     */
    private async clickOK() {

        //設定時間チェック
        if (this.inputTime1 == "" || this.inputTime2 == "") {   //何も入っていない場合
            this.validateMessage = "時間を正しく指定してください。";
            return false;
        } else if (this.inputTime1 >= this.inputTime2) {    //時間が逆の場合
            this.validateMessage = "時間を正しく指定してください。";
            return false;
        }

        //エラーメッセージを初期化
        this.validateMessage = null;

        //曜日チェック
        if (this.input_day_of_the_week.length == 0) {
            //曜日が何も入っていない場合
            //ダイアログ指定
            const modalRef_confirm = this.modalService.open(SimpleDialogContent);
            const component_confirm = modalRef_confirm.componentInstance as SimpleDialogContent;

            //各値設定
            component_confirm.title = "設定不可";
            component_confirm.message = "曜日を指定してください。";
            component_confirm.button = "ok";
            return false;
        } else {
            //曜日が何か入っている場合
            //'ok'を返す
            this.activeModal.close('ok');
        }
    }

    /**
     * 初期化ボタン押下処理
     */
    private async clickReset() {

        //ダイアログ指定
        const modalRef_reset = this.modalService.open(SimpleDialogContent);
        const component_reset = modalRef_reset.componentInstance as SimpleDialogContent;

        //各値設定
        component_reset.title = "確認";
        component_reset.button = "okCancel";
        component_reset.message = "登録不可時間を初期化します。\nよろしいですか？";

        //ボタン押下結果格納
        const result_reset = await modalRef_reset.result;

        //ボタン結果判定
        if (result_reset == 'ok') {
            //'ok'の場合
            //'reset'を返す
            this.activeModal.close('reset');
        } else {
            //それ以外の場合
            return;
        }
    }

    /**
     * 曜日の色を更新する
     */
    async changeColorDayOfTheWeek() {
        //曜日（0〜6：日〜土）
        let dayOfTheWeek = ['0', '1', '2', '3', '4', '5', '6'];

        //曜日の数だけ繰り返す（7回）
        for (var i = 0; i < dayOfTheWeek.length; i++) {
            //青色にする曜日と一致する曜日かどうか判定
            if (!this.input_day_of_the_week.some(function (value) {
                //一致する場合はtrueを返す
                return value == dayOfTheWeek[i];
            })) {
                //一致した（true）場合
                //ボタンの色変更処理（0：灰色）
                this.settingColorDayOfTheWeek(dayOfTheWeek[i], '0');
            } else {
                //一致しなかった（false）場合
                //ボタンの色変更処理（1：青色）
                this.settingColorDayOfTheWeek(dayOfTheWeek[i], '1');
            }
        }
    }

    /**
     * 色更新処理
     * 
     * @param num 曜日（0〜6：日〜土）
     * @param in_color 色指定（0：灰色  1：青色）
     */
    private async settingColorDayOfTheWeek(num: string, in_color: string) {
        //色判定
        if (in_color == '0') {
            //灰色にする場合
            switch (num) {
                case '0': document.getElementById("sun").className = "btn btn-secondary mr-auto";
                    break;
                case '1': document.getElementById("mon").className = "btn btn-secondary mr-auto";
                    break;
                case '2': document.getElementById("tue").className = "btn btn-secondary mr-auto";
                    break;
                case '3': document.getElementById("wed").className = "btn btn-secondary mr-auto";
                    break;
                case '4': document.getElementById("thu").className = "btn btn-secondary mr-auto";
                    break;
                case '5': document.getElementById("fri").className = "btn btn-secondary mr-auto";
                    break;
                case '6': document.getElementById("sat").className = "btn btn-secondary mr-auto";
                    break;
            }
        } else {
            //青色にする場合
            switch (num) {
                case '0': document.getElementById("sun").className = "btn btn-primary";
                    break;
                case '1': document.getElementById("mon").className = "btn btn-primary";
                    break;
                case '2': document.getElementById("tue").className = "btn btn-primary";
                    break;
                case '3': document.getElementById("wed").className = "btn btn-primary";
                    break;
                case '4': document.getElementById("thu").className = "btn btn-primary";
                    break;
                case '5': document.getElementById("fri").className = "btn btn-primary";
                    break;
                case '6': document.getElementById("sat").className = "btn btn-primary";
                    break;
            }
        }
    }

    /**
     * 各曜日押下処理
     * 
     * @param num 曜日（0〜6：日〜土）
     */
    private async clickDayOfTheWeek(num: string) {
        //青色にする曜日の中に、押下した曜日が含まれているか判定
        if (this.input_day_of_the_week.some(function (value) {
            //含まれているならtrueを返す
            return value == num;
        })) {
            //含まれている場合
            //一致する要素の番号を格納。その番号の要素を削除。
            const index = this.input_day_of_the_week.indexOf(num);
            this.input_day_of_the_week.splice(index, 1);
        } else {
            //含まれていない場合
            //青色にする曜日の配列に追加
            this.input_day_of_the_week.push(num);
        }
        this.changeColorDayOfTheWeek();
    }
}
